import React from "react";
import PropTypes from "prop-types";

import DialogFormWithMutation from "dialogs/DialogFormWithMutation";
import AddEditAccountFields from "./AddEditAccountFields";
import useFormValidator from "hooks/useFormValidator";

import { GET_ACCOUNTS_NAME, UPDATE_ACCOUNT } from "graphqlQueries/accounts";
import { updateAccountExtendValidator } from "validators/updateAccountExtendValidator";

const fieldsWithPlaceForError = [
  "name",
  "description",
  "pmn_amount",
  "ipmp_user",
  "password",
];

const EditAccountDialog = (props) => {
  const { accountInfo } = props;
  const { validationSchema } = useFormValidator(
    "update_ipmp",
    {
      name: "System name",
      pmn_amount: "Max. instances",
      password: "Password",
    },
    updateAccountExtendValidator,
  );

  const initialValues = {
    id_ipmp: accountInfo.id,
    name: accountInfo.name,
    description: accountInfo.description,
    pmn_amount: accountInfo.registeredLimit,
    ipmp_user: accountInfo.ipmp_user,
    enabled: accountInfo.enabled,
    password: "",
    confirm_password: "",
  };

  const dataMapper = (data) => {
    const data_ = JSON.parse(JSON.stringify(data));
    delete data_.ipmp_user;
    data_.password === "" && delete data_.password;
    return data_;
  };

  return (
    <DialogFormWithMutation
      mutationQueries={UPDATE_ACCOUNT}
      refetchQueries={[GET_ACCOUNTS_NAME]}
      initialValues={initialValues}
      dataMapper={dataMapper}
      validationSchema={validationSchema}
      fieldsWithPlaceForError={fieldsWithPlaceForError}
      title={`Edit account ${accountInfo.name}`}
      submitButtonName="Save"
      className="dialog-default-width"
      {...props}
    >
      <AddEditAccountFields editDialog />
    </DialogFormWithMutation>
  );
};

EditAccountDialog.propTypes = {
  accountInfo: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default EditAccountDialog;
